import BusinessMetricsLayout from './BusinessMetricsLayout';
import NewUsersAddedMetrics from './NewUsersAddedMetrics';
import NewWorkspaceCreatedMetrics from './NewWorkspaceCreatedMetrics';

const NewWorkspaceAndUsersMetricsLayout = () => (
  <BusinessMetricsLayout>
    <>
      <NewWorkspaceCreatedMetrics />
      <NewUsersAddedMetrics />
    </>
  </BusinessMetricsLayout>
);

export default NewWorkspaceAndUsersMetricsLayout;
